import { useWebSocket } from "WebSocketContext";
import { useState } from "react";

export default function ConnectionStatus() {
  const {isConnected, playerId } = useWebSocket();

  const [showStatus, setShowStatus] = useState(false);

  const statusIcon = !isConnected
    ? "❌"
    : "✅"

  return (
    <div onClick={() => setShowStatus(!showStatus) } className={`
      cursor-pointer
      transition duration-500 absolute top-0 right-0 flex flex-col items-end m-2 border-2 p-2 z-[999]
      ${showStatus ? "border-black bg-[#BCB7A8]": "border-transparent bg-transparent"}
    `}>
      {showStatus ? (
        <>
          <p>Connection Status: {isConnected ? "Connected " : "Disconnected "}{statusIcon}</p>
          { isConnected && (
            <p>Connected as: { playerId }</p>
          )}
        </>
      ) : (
        <p>{statusIcon}</p>
      )}
    </div>

  )
}
